module.exports = __webpack_public_path__ + "static/img/openstack.8cbba36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/openstack.png
// module id = 5ykC
// module chunks = 0